/* eslint-disable */
import api from './api';

const triggerPixelIframe = (event, sale, ref) => {
  const notificationObj = {
    event_type: 'track',
    event,
  };

  if (event === 'Purchase' || event === 'BoletoGerado') {
    notificationObj['content_data'] = sale;
    window.fbq('track', 'Purchase', sale);
  }

  try {
    console.log(JSON.stringify(notificationObj));
    ref.current.contentWindow.postMessage(JSON.stringify(notificationObj), '*');
  } catch (error) {
    console.log(`[error] [triggerPixelIframe] -> `, error);
  }
};

export const triggerPixel = (event, sale, ref = null) => {
  if (event === 'initiate-checkout') {
    console.log('firedinitiate-checkout');

    if (ref) {
      triggerPixelIframe('InitiateCheckout', sale, ref);
    } else {
      // window.fbq('track', 'InitiateCheckout');
    }

    window.ttq.track('InitiateCheckout');
  }
  if (event === 'add-payment-info') {
    console.log('fired add-payment-info');

    console.log(ref);
    if (ref) {
      triggerPixelIframe('AddPaymentInfo', sale, ref);
    } else {
      // window.fbq('track', 'AddPaymentInfo');
    }
    window.ttq.track('AddPaymentInfo');
  }
  if (event === 'boleto') {
    console.log('boleto fired');
    if (ref) {
      triggerPixelIframe('BoletoGerado', sale, ref);
    }
  }
  if (event === 'purchase') {
    console.log('fired purchase');

    let params = {
      value: sale.value,
      currency: 'BRL',
    };
    let facebookParams = params;
    facebookParams.transaction_id = sale.contents[0].uuid;
    // facebookParams.payment_type = sale.payment_method;

    let tiktokParams = facebookParams;
    tiktokParams.content_id = sale.contents[0].uuid;

    // if (ref) {
    //   triggerPixelIframe('Purchase', sale, ref);
    // } else {
    window.fbq('track', 'Purchase', facebookParams);
    // }
    window.ttq.track('CompletePayment', tiktokParams);
  }
};

export const dispatchPixelEvent = (
  event,
  event_name,
  custom_data,
  fb_pixels
) => {
  // verify fb pixels
  if (fb_pixels && fb_pixels.length > 0) {
    fb_pixels.forEach((p) => {
      console.log(p);
      triggerPixel(event, custom_data, p.ref);
      if (p.api_token) {
        const data = {
          pixel_uuid: p.pixel_uuid,
          event_name,
          custom_data,
          event_id: event_name.toLowerCase() + '_' + p.event_id,
          test_event_code: p.test_event_code,
        };
        api
          .post('/cart/pixel', data)
          .then((response) => {
            console.log(response.data);
          })
          .catch((err) => console.log(err));
      }
    });
  } else {
    triggerPixel(event);
  }
};

export const triggerPixelPurchaseBoleto = (pixels, sale) => {
  let params = {
    value: sale.amount,
    currency: 'BRL',
  };

  if (pixels.facebook.length > 0) {
    if (pixels.facebook[0].settings.trigger_purchase_boleto) {
      let facebookParams = params;
      facebookParams.transaction_id = sale.sale_id;
      facebookParams.payment_type = 'billet';
      window.fbq('track', 'Purchase', facebookParams);
    }
  }

  if (pixels.tiktok.length > 0) {
    if (pixels.tiktok[0].settings.trigger_purchase_boleto) {
      let tiktokParams = params;
      tiktokParams.transaction_id = sale.sale_id;
      tiktokParams.payment_type = 'billet';
      window.ttq.track('CompletePayment', tiktokParams);
    }
  }
};

export const getTotalAmountInstallment = (
  offer,
  selectedBumps,
  selectedInstallment
) => {
  return;
};

export const currency = (amount, currencyOption = 'brl') => {
  // let currencyOption = '';
  let locale = '';
  if (currencyOption === 'brl') {
    locale = 'pt-BR';
  }
  if (currencyOption === 'usd') {
    locale = 'en-US';
  }

  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyOption,
  }).format(amount);
};

export const time = () => {
  return Math.round(Date.now() / 1000);
};

export const validatePhone = (value, resident) => {
  if (!value) return false;
  if (resident === 'brasil') {
    if (value.replace(/\D/g, '').length !== 11) {
      return false;
    }
    if (value.charAt(2) !== '9') {
      return false;
    }
    return true;
  }
  if (resident === 'exterior') {
    if (value.replace(/\D/g, '').length < 7) {
      return false;
    }
    return true;
  }
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateName = (name) => {
  let explode = name.split(' ');
  if (explode[1]) {
    return true;
  } else {
    return false;
  }
};
// export const validateName = (name) => {
//   const re = /^([a-zA-Z]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/;
//   return re.test(name);
// };
export const cleanDocument = (document) => {
  return document.replaceAll('.', '').replaceAll('-', '');
};

export const hasQueryParams = (url) => {
  return url.indexOf('?') !== -1;
};

export const colorShade = (col, amt) => {
  col = col.replace(/^#/, '');
  if (col.length === 3)
    col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];

  let [r, g, b] = col.match(/.{2}/g);
  [r, g, b] = [
    parseInt(r, 16) + amt,
    parseInt(g, 16) + amt,
    parseInt(b, 16) + amt,
  ];

  r = Math.max(Math.min(255, r), 0).toString(16);
  g = Math.max(Math.min(255, g), 0).toString(16);
  b = Math.max(Math.min(255, b), 0).toString(16);

  const rr = (r.length < 2 ? '0' : '') + r;
  const gg = (g.length < 2 ? '0' : '') + g;
  const bb = (b.length < 2 ? '0' : '') + b;

  return `#${rr}${gg}${bb}`;
};

export const pixelNative = (event, data) => {
  window.fbq('track', event, data);
};

export const pixelTikTok = (event, data) => {
  window.ttq.track(event, data);
};

export const googleAnalyticsSend = (event, data, gtmID) => {
  gtag('event', event, data);
};

export const injectGoogleTagManager = (gtmID) => {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmID}`;

  script.async = true;
  head.appendChild(script);

  const script2 = document.createElement('script');
  script2.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gtmID}');
  `;
  head.appendChild(script2);
};

export const googleAdsSend = (data) => {
  gtag('event', 'conversion', data);
};
